// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "stub__content-2kEVy";
var _5 = "stub__image-3c69i";
var _6 = "stub__imageWrapper-1RYwe";
var _7 = "stub__buttons-GUnQn";
var _8 = "stub__button-37IEF";
var _9 = "stub__planeIcon-1FZx7";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "stub__content", _5 as "stub__image", _6 as "stub__imageWrapper", _7 as "stub__buttons", _8 as "stub__button", _9 as "stub__planeIcon" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "stub__content": _4, "stub__image": _5, "stub__imageWrapper": _6, "stub__buttons": _7, "stub__button": _8, "stub__planeIcon": _9 }
